module.exports = __webpack_public_path__ + "img/quick-quote-logo.44fd5ff7.png";